/**
 * WARNING: DEPRECATED & NEEDS REWRITE
 *
 * Given the number of issues we've had with this widget, we should consider this
 * deprecated. Existing functionality is expected to continue to work, but any changes
 * or improvements should consider reworking the entirety of this component.
 *
 * This embed.js is featured on https://reverb.com/page/embedded-listings as a way to
 * allow external sites to embed reverb listings and collections. As a result we
 * have to follow some diffferent standards:
 *
 * 1. jQuery is the only library present
 * 2. ES5 only
 * 3. No imports/requires
 *
 * After any deploy we'll need to bust the cache in at least two places:
 * 1. Legacy (CloudFront managed) - https://d1g5417jjjo7sf.cloudfront.net/assets/embed/reverb.js
 * 2. Fastly - TODO: URL coming post initial deploy
 *
 * We want to migrate folks to the fastly asset as the domain is owned by us
 * instead of tied to cloudfront.
 *
 * WARNING: The templaing in this file is homerolled and has experienced XSS issues
 * a number of times. Any investment in emeddable listings should include some migration
 * of this library to something more modern & secure.
 */
window.Reverb = window.Reverb || {};

/*!
    Underscore.js templates as a standalone implementation.
    JavaScript micro-templating, similar to John Resig's implementation.
    Underscore templates documentation: http://documentcloud.github.com/underscore/#template
    Modifyed by marlun78
*/
(function () {
  'use strict';

    // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.
  var settings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g
  };

    // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.
  var noMatch = /.^/;

    // Certain characters need to be escaped so that they can be put into a
    // string literal.
  var escapes = {
    '\\': '\\',
    '\'': '\'',
    'r': '\r',
    'n': '\n',
    't': '\t',
    'u2028': '\u2028',
    'u2029': '\u2029'
  };

  for (var p in escapes) {
    escapes[escapes[p]] = p;
  }

  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

  var tmpl = function (text, data, objectName) {
    settings.variable = objectName;
    // these templates are completely unsafe for any untrusted input
    // unfortunately we also have an endpoint that will echo back whatever
    // you select at `/cors` via a path traversal hack
    data = JSON.parse(JSON.stringify(data).replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;'));

    // Compile the template source, taking care to escape characters that
    // cannot be included in a string literal and then unescape them in code
    // blocks.
    var source = '__p+=\'' + text
            .replace(escaper, function (match) {
              return '\\' + escapes[match];
            })
            .replace(settings.interpolate || noMatch, function (match, code) {
              return '\'+\n(' + unescape(code) + ')+\n\'';
            })
            .replace(settings.evaluate || noMatch, function (match, code) {
              return '\';\n' + unescape(code) + '\n;__p+=\'';
            }) + '\';\n';

        // If a variable is not specified, place data values in local scope.
    if (!settings.variable) {
      source = 'with(obj||{}){\n' + source + '}\n';
    }

    source = 'var __p=\'\';var print=function(){__p+=Array.prototype.join.call(arguments, \'\')};\n' + source + 'return __p;\n';

    var render = new Function(settings.variable || 'obj', source);

    if (data) {
      return render(data);
    }

    var template = function (data) {
      return render.call(this, data);
    };

        // Provide the compiled function source as a convenience for build time
        // precompilation.
    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';

    return template;
  };

  Reverb.tmpl = tmpl;
}());

// Quick high level extraction to DRY out embeddedListings and embeddedComparisonShoppingPage
// Renderers can probably be moved over too, as well as api options.

Reverb.sharedEmbeddingFunctionality = function (renderer) {
  function extractQueryOptions(container) {
    var USER_SUPPLIED_MAKES = 'makes';
    var API_MAKE_ARRAY_OPTION = 'make[]';
    var options = {};

    $.each($(container).data(), function (k, v) {
      if (k.match(/reverbSearch/)) {
        var paramName = snake_case(k.replace('reverbSearch', ''));

        // special case: user can specify data-reverb-search-makes='comma,delimited' to get multiple makes
        if (paramName === USER_SUPPLIED_MAKES) {
          options[API_MAKE_ARRAY_OPTION] = v.split(',');
        } else {
          options[paramName] = v;
        }
      }
    });

    // Add GrowSumo/PartnerStack id
    var gsPartnerId = $(container).data('reverb-gs-partner');

    if (gsPartnerId) {
      options['gs_partner'] = gsPartnerId;
    }

    var currency = $(container).data('reverb-currency') || 'USD';
    options['currency'] = currency;

    // Add utm params
    options['utm_source'] = 'js_embed';
    options['utm_campaign'] = 'affiliate_embed';

    return options;
  }

  // turns camelCaseWord into camel_case_word
  // Used for parsing data attributes, whose keys are camelized
  function snake_case(camelCaseWord) {
    return camelCaseWord.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
  }

  // Invokes the API function specified. The argumentName specifies the primary
  // argument such as the collection name or article slug which is used to construct
  // the API url. The container specifies where the results should go, and acts
  // as a storage for all the additional api options.
  function embedFromAPI(apiFunction, argumentName, container) {
    var argument = container.data(argumentName);
    var options = extractQueryOptions(container);

    if (apiFunction.length === 1) {
      // Some API functions take only the options hash
      apiFunction(options).done(renderer(container));
    } else {
      // Others take the name of the collection, plus the options hash
      apiFunction(argument, options).done(renderer(container));
    }
  }

  return {
    embedFromAPI: embedFromAPI
  };
};

//  Usage:
//
//  var api = new Reverb.API();
//  var per_page = 5;
//
//  api = new Reverb.API({baseURL: "http://reverb.site/api/"})
//  api.searchListings({query: "fender", price_max: "1"}).done(function(data) { console.log(data.listings) });
//
//  The API uses jquery's ajax method and supports the standard promises interface
//
//  Note that the searchListings will default to condition: 'all'
//
//
Reverb.API = function (options) {
  if (!options) { options = {}; }
  var apiToken = options.apiToken;
  var baseURL = options.baseURL || 'https://reverb.com/api/';

  if (baseURL.slice(-1) !== '/') {
    baseURL += '/';
  }

  function requestHeaders(currency) {
    var headers = {};
    headers['X-Reverb-App'] = 'reverb.js';
    headers['X-Reverb-Embed-Location'] = window.location.href;

    if (currency) {
      headers['X-Display-Currency'] = currency;
    }

    if (apiToken) {
      headers['X-Auth-Token'] = apiToken;
    }
    return headers;
  }

  function get(url, queryOptions) {
    baseURL = queryOptions.base_url || baseURL;
    var currency = queryOptions['currency'];
    delete(queryOptions['currency']);
    var headers = requestHeaders(currency);
    return $.ajax({
      url: baseURL + url,
      data: queryOptions,
      type: 'GET',
      dataType: 'json',
      headers: headers,
      error: function (error) { console.log(error); }
    });
  }

  function searchListings(queryOptions) {
    var options = $.extend({ condition: 'all' }, queryOptions);
    return get('listings', options);
  }

  function searchAffiliate(queryOptions) {
    var options = $.extend({}, queryOptions, { sort: 'random' });
    return get('collections/affiliate-product-pool', options);
  }

  function handpicked(name, queryOptions) {
    return get('handpicked/' + name, queryOptions);
  }

  function collection(name, queryOptions) {
    return get('collections/' + name, queryOptions);
  }

  function searchPriceguide(queryOptions) {
    return get('priceguide', queryOptions);
  }

  function listingsRelatedToArticle(slug, queryOptions) {
    return get('articles/' + slug + '/related-listings', queryOptions);
  }

  function comparisonShoppingPage(slug, queryOptions) {
    options = queryOptions || {};
    return get('comparison_shopping/' + slug, options);
  }

  return {
    handpicked: handpicked,
    collection: collection,
    searchListings: searchListings,
    searchPriceguide: searchPriceguide,
    listingsRelatedToArticle: listingsRelatedToArticle,
    searchAffiliate: searchAffiliate,
    comparisonShoppingPage: comparisonShoppingPage
  };
};

//   Example: provide a container in the DOM to hold the listings pulled
//   from the Reverb service.
//
//  -> (a specific search)
//
//  <div data-reverb-embed-listings
//       data-reverb-search-query="something"
//       data-reverb-search-category="electric-guitars"
//       data-reverb-search-price-max="500"
//       data-reverb-search-price-min="100"
//       data-reverb-search-year-max="1979"
//       data-reverb-search-year-min="1970"
//       data-reverb-search-make="fender"
//       data-reverb-search-model="stratocaster"
//       data-reverb-search-per-page="3"
//       data-template="#sidebar-listings-template"></div>
//
//  The following examples use the same page and template options; They have been
//  omitted for brevity to show just the parts that change.
//
//  -> deals under $100
//  <div  data-reverb-embed-handpicked
//        data-reverb-collection-name="deals"
//        data-reverb-search-price-max="100"
//        data-reverb-search-per-page='3'
//        data-template="#blog-inline-720-listings-template"></div>
//
//  -> a curated search (featured collection)
//  <div data-reverb-embed-collection data-reverb-collection-name="80s-strats"></div>
//
//  -> listings related to an article
//  <div data-reverb-embed-related-listings data-article-slug="my-article" data-reverb-search-per-page='3'></div>
//
//
//  You can add an gs-partner id as well
//  <div data-reverb-gs-partner='affiliate-code' data-reverb-embed-collection data-reverb-collection-name="80s-strats"></div>
//
Reverb.EmbeddedComparisonShopping = (function (options) {
  var api;

  if (!options) { options = {}; }

  if (options.apiURL) {
    api = new Reverb.API({ baseURL: options.apiURL });
  } else {
    api = new Reverb.API();
  }

  var sharedEmbeddingFunctionality = new Reverb.sharedEmbeddingFunctionality(renderer);

  var verticalTemplate = '                                                                                                        \
    <ul class=\'reverb-embedded-comparison-shopping-pages-vertical clearfix\'>                                                      \
      <a target=\'_top\' class=\'reverb-comparison-shopping-page-embed\' href=\'<%= comparison_shopping_page._links.web.href %>\'>                    \
        <li class=\'reverb-embedded-comparison-shopping-page\'>                                                                     \
          <div class=\'reverb-embedded-comparison-shopping-page-image-overlay\'>                                                    \
            <% if (comparison_shopping_page.photos[0]) { %>                                                                          \
              <img src=\'<%= comparison_shopping_page.photos[0]._links.small_crop.href %>\' height=\'auto\' width=\'100%\'/>              \
            <% } %>                                                                                                                  \
            <div class=\'reverb-embedded-comparison-shopping-page-image-overlay-gradient\'></div>                                   \
            <div class=\'reverb-embedded-comparison-shopping-page-prices\'>                                                         \
              <span class=\'reverb-embedded-comparison-shopping-page-price\'>                                                       \
                <% if (comparison_shopping_page.used_total > 0) { %>                                                              \
                  <%= comparison_shopping_page.used_total %> used from                                                            \
                  <%= comparison_shopping_page.used_low_price.symbol %><%= comparison_shopping_page.used_low_price.amount %>      \
                <% } %>                                                                                                           \
              </span><br/>                                                                                                        \
              <span class=\'reverb-embedded-comparison-shopping-page-price\'>                                                       \
                <% if (comparison_shopping_page.new_total > 0) { %>                                                               \
                  <%= comparison_shopping_page.new_total %> new from                                                              \
                  <%= comparison_shopping_page.new_low_price.symbol %><%= comparison_shopping_page.new_low_price.amount %>        \
                <% } %>                                                                                                           \
              </span>                                                                                                             \
            </div>                                                                                                                \
          </div>                                                                                                                  \
          <div class=\'reverb-embedded-comparison-shopping-page-bottom-content\'>                                                   \
            <span class=\'reverb-embedded-comparison-shopping-page-title\'><%= comparison_shopping_page.title %></span>             \
            <div class=\'reverb-embedded-comparison-shopping-page-summary\'><%= comparison_shopping_page.summary %></div>  \
          </div>                                                                                                                  \
        </li>                                                                                                                     \
      </a>                                                                                                                        \
    </ul>                                                                                                                         \
  ';

  var horizontalTemplate = '                                                                                                      \
    <ul class=\'reverb-embedded-comparison-shopping-pages-horizontal clearfix\'>                                                    \
      <a target=\'_top\' class=\'reverb-comparison-shopping-page-embed\' href=\'<%= comparison_shopping_page._links.web.href %>\'>      \
        <li class=\'reverb-embedded-comparison-shopping-page\'>                                                                     \
          <div class=\'reverb-embedded-comparison-shopping-page-left-content\'>                                                     \
            <% if (comparison_shopping_page.photos[0]) { %>                                                                          \
              <img src=\'<%= comparison_shopping_page.photos[0]._links.small_crop.href %>\' height=\'auto\' width=\'100%\'/>              \
            <% } %>                                                                                                                  \
          </div>                                                                                                                  \
          <div class=\'reverb-embedded-comparison-shopping-page-right-content\'>                                                    \
            <span class=\'reverb-embedded-comparison-shopping-page-title\'><%= comparison_shopping_page.title %></span>             \
            <div class=\'reverb-embedded-comparison-shopping-page-summary\'><%= comparison_shopping_page.summary %></div>  \
            <div class=\'reverb-embedded-comparison-shopping-page-prices\'>                                                         \
              <% if (comparison_shopping_page.used_total > 0) { %>                                                                \
                <span class=\'reverb-embedded-comparison-shopping-page-price\'>                                                     \
                  <%= comparison_shopping_page.used_total %> used from                                                            \
                  <span class=\'reverb-embedded-comparison-shopping-page-price-amount\'>                                            \
                    <%= comparison_shopping_page.used_low_price.symbol %><%= comparison_shopping_page.used_low_price.amount %>    \
                  </span>                                                                                                         \
              </span>                                                                                                             \
              <% } %>                                                                                                             \
              <% if (comparison_shopping_page.new_total > 0) { %>                                                                 \
                <span class=\'reverb-embedded-comparison-shopping-page-price\'>                                                     \
                  <%= comparison_shopping_page.new_total %> new from                                                              \
                  <span class=\'reverb-embedded-comparison-shopping-page-price-amount\'>                                            \
                    <%= comparison_shopping_page.new_low_price.symbol %><%= comparison_shopping_page.new_low_price.amount %>      \
                  </span>                                                                                                         \
                </span>                                                                                                           \
              <% } %>                                                                                                             \
            </div>                                                                                                                \
          </div>                                                                                                                  \
        </li>                                                                                                                     \
      </a>                                                                                                                        \
    </ul>                                                                                                                         \
 ';

  function renderer(container) {
    var container = $(container);
    var template = $(container.data('reverb-template'));
    var orientation = container.data('reverb-orientation');

    if (template.length) {
      template = template.html();
    } else if (orientation === 'horizontal') {
      template = horizontalTemplate;
    } else {
      template = verticalTemplate;
    }
    return function (data) {
      var html = Reverb.tmpl(template, { comparison_shopping_page: data });
      container.hide().append(html).fadeIn();
    };
  }

  function init() {
    $('[data-reverb-comparison-shopping-page-slug]').each(function () {
      sharedEmbeddingFunctionality.embedFromAPI(api.comparisonShoppingPage, 'reverb-comparison-shopping-page-slug', $(this));
    });
  }

  return {
    init: init
  };
});

Reverb.EmbeddedListings = (function (options) {
  var api;

  if (!options) { options = {}; }

  if (options.apiURL) {
    api = new Reverb.API({ baseURL: options.apiURL });
  } else {
    api = new Reverb.API();
  }

  var sharedEmbeddingFunctionality = new Reverb.sharedEmbeddingFunctionality(renderer);

  var defaultTemplate = '                                                 \
    <ul class=\'reverb-embedded-listings clearfix\'>                                \
      <% $.each(listings, function (index, listing) { %>                          \
      <li class=\'reverb-embedded-listing\'>                                        \
        <a target=\'_blank\' rel=\'noopener\' class=\'reverb-listing-embed\' href=\'<%= listing._links.web.href %>\'>    \
          <img src=\'<%= listing.photos[0]._links.small_crop.href %>\'></img>       \
          <div class=\'reverb-embedded-listing-info\'>                              \
          <span class=\'reverb-embedded-listing-title\'><%= listing.title %></span> \
          <span class=\'reverb-embedded-listing-price\'>                            \
            <%= listing.price.symbol %>                                           \
            <%= listing.price.amount %>                                           \
          </span>                                                                 \
          </div>                                                                  \
        </a>                                                                      \
      </li>                                                                       \
      <%})%>                                                                      \
    </ul>                                                                         \
  ';

  function renderer(container) {
    var container = $(container);
    var template = $(container.data('template'));

    if (template.length) {
      template = template.html();
    } else {
      template = defaultTemplate;
    }

    return function (data) {
      var html = Reverb.tmpl(template, { listings: data.listings });

      container.hide().append(html).fadeIn();
    };
  }

  // Pulls all data values prefixed as reverb-search-* from the container
  // element and turns them into a hash of underscored values.
  //
  // e.g. <div data-reverb-search-price-max="500"/> will turn into {"price_max": "500"}

  function init() {
    $('[data-reverb-embed-affiliate]').each(function () {
      sharedEmbeddingFunctionality.embedFromAPI(api.searchAffiliate, null, $(this));
    });

    $('[data-reverb-embed-listings]').each(function () {
      sharedEmbeddingFunctionality.embedFromAPI(api.searchListings, null, $(this));
    });

    $('[data-reverb-embed-handpicked]').each(function () {
      sharedEmbeddingFunctionality.embedFromAPI(api.handpicked, 'reverb-collection-name', $(this));
    });

    $('[data-reverb-embed-collection]').each(function () {
      sharedEmbeddingFunctionality.embedFromAPI(api.collection, 'reverb-collection-name', $(this));
    });

    $('[data-reverb-embed-related-listings]').each(function () {
      sharedEmbeddingFunctionality.embedFromAPI(api.listingsRelatedToArticle, 'article-slug', $(this));
    });
  }

  return {
    init: init
  };
});

$(function () {
  // For development mode to run against your local api, use this to make it
  // hit your local API endpoint. Otherwise, it hits reverb.com/api
  // var embedder = new Reverb.EmbeddedListings({apiURL: "//" + window.location.host + "/api/"});
  var listingsEmbedder = new Reverb.EmbeddedListings();
  var comparisonShoppingEmbedder = new Reverb.EmbeddedComparisonShopping();
  comparisonShoppingEmbedder.init();
  listingsEmbedder.init();
});



// WEBPACK FOOTER //
// ./javascripts/embed/reverb.js